import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import egglogo from '../logosnfl/egg.png';
import '../css/Navbar.css';

function NavBar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar-container">
      <div className="navbar-logo-wrapper">
        <img src={egglogo} alt="eggModels logo" className="navbar-logo" />
      </div>
      <nav className="navbar">
        <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
          Home
        </NavLink>

        <div
          className="dropdown"
          ref={dropdownRef}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <NavLink
            to="/nfl"
            end={false}
            className={({ isActive }) =>
              `dropdown-toggle${isActive ? ' active' : ''}`
            }
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            NFL
          </NavLink>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <NavLink
                to="/nfl/parlay"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Parlay
              </NavLink>
              <NavLink
                to="/nfl/rankings"
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                Rankings
              </NavLink>
            </div>
          )}
        </div>

        <NavLink to="/tennis" className={({ isActive }) => (isActive ? 'active' : '')}>
          Tennis
        </NavLink>

        <NavLink to="/blog" className={({ isActive }) => (isActive ? 'active' : '')}>
          Blog
        </NavLink>
      </nav>
    </div>
  );
}

export default NavBar;
